/** DialogContent padding matching `DialogHeader`. */
export const DIALOG_CONTENT_SX = { px: { xs: 2.5, sm: 3 }, py: 3 } as const;

/** DialogActions padding + top hairline matching `DialogHeader`. */
export const DIALOG_ACTIONS_SX = { px: { xs: 2.5, sm: 3 }, py: 2, borderTop: 1, borderColor: 'divider' } as const;
